<template>
  <!-- 遮罩层 -->
  <div class="alert-mask" v-if="visible" @click="close">
    <!-- 弹窗主体 -->
    <div class="alert-box" @click.stop>
      <div class="alert-header"></div>
      <div class="alert-content">
        <!-- 显示IP内容 -->
        {{ content }}
      </div>
      <div class="alert-footer">
        <button @click="close">确定</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

// 接收父组件传值：是否显示、弹窗内容
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  content: {
    type: String,
    default: "",
  },
});

// 触发关闭事件给父组件
const emit = defineEmits(["close"]);
const close = () => {
  emit("close");
};
</script>

<style scoped>
/* 遮罩层样式 */
.alert-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 弹窗主体 */
.alert-box {
  width: 300px;
  background: white;
  border-radius: 8px;
  padding: 0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.alert-header {
  padding: 15px;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
}

.alert-content {
  padding: 20px 15px;
  font-size: 14px;
  color: #333;
}

.alert-footer {
  padding: 10px 15px;
  text-align: center;
  border-top: 1px solid #eee;
}

.alert-footer button {
  padding: 6px 12px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>